import React, { Component } from 'react';
import { DashboardLayout } from '../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import Rating from '@material-ui/lab/Rating';
import { itemService, globalService as gs } from '../../../common/services';
import moment from 'moment-timezone';
import { alertSelectors } from '../../../common/redux/selectors';
import { defaultActions } from '../../../common/redux/actions';
import { orderStatus } from '../../../helpers';
import ProfileVerified from '../Common/ProfileVerified';

class TutorDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bookingItems: null,
            loading: false,
        };
    }

    componentDidMount() {
        const { dispatch, config } = this.props;
        (config.config === null) && dispatch(defaultActions.config());
        this.setState({loading: true});
        itemService.booking().then(data => {
            if(data.code) {
                let bookingItems = data.items;
                this.setState({bookingItems, loading: false});
            }
        })
        .catch(exception => {
            gs.showErrors(exception, dispatch, alertSelectors);
            this.setState({loading: false});
        });
    }

    totalPrice = (price) => {
        if (parseFloat(price) === 0) { return '0.00'; }
        const { config } = this.props.config;
        const commission_rate = config && config.commission_rate;
        price = price ? price : 0;
        const tax = parseFloat(price) * parseFloat(commission_rate) / 100;
        return (parseFloat(price) - parseFloat(tax)).toFixed(2);
    }
    
    render() {
        const { bookingItems, loading } = this.state;
        return (<DashboardLayout>
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box d-flex justify-content-between">
                            <h2 className="mb-0 page-title">Dashboard</h2>
                            <ProfileVerified />
                        </div>
                    </div>
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h3 className="mb-0 page-subtitle">My Bookings</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {(loading) ? <>
                            {[1,2].map((item) =>
                                <div className="post-box mb-4" key={`bok-${item}`}>
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                </div>
                            )}
                        </> : <>
                            {bookingItems && bookingItems.slice(0, 4).map(book =>
                                <div className="post-box mb-4" key={`book-${book.id}`}>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-12">
                                            <div className="media">
                                                <div className="image">  
                                                    <img className="mr-4 img-circle" src={book.user && book.user.avatar} alt="pic" width="70" height="70" />
                                                </div>
                                                <div className="media-body">
                                                    <h5>{book.user && book.user.name}</h5>
                                                    <div className="rating mb-2">
                                                        <span className="star">
                                                            {(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg) &&
                                                                <Rating name="size-medium" value={parseInt(book.userCatalogOrdersItems[0].user.rating_avg)} readOnly />}
                                                        </span>
                                                        <span> ({book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg}) {book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.count_rating} Ratings</span>
                                                    </div>
                                                    <div className="location">
                                                        <i className="fas fa-map-marker-alt"></i> {book.user && book.user.countryCode && book.user.countryCode.name}
                                                    </div> 
                                                </div> 
                                            </div>       
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="inform mt-4">
                                                <div className="d-flex">
                                                    <label>Date:</label>
                                                    <div className="date">  
                                                        {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).format('MM/DD/YYYY')}<br/> {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).format('LT')} - {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).add(60, 'minutes').format('LT')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 col-6">
                                            <div className="inform mt-4">
                                                <div className="d-flex">
                                                    <label>Cost:</label>
                                                    <div className="date">  
                                                        ${this.totalPrice(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].price)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="inform">
                                                <div className="d-flex">
                                                    <label>Duration:</label>
                                                    <div className="date">  
                                                        60 min
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-12 col-12 d-flex justify-content-between">
                                            <div className="sub mt-4">
                                                {/* <button className="btn btn-light">{book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].catalog.title}</button> */}
                                                <span className={`badge badge-${orderStatus.status(book).cls}`}>{orderStatus.status(book).title}</span>
                                            </div>
                                            <div className="view mt-4">
                                                <Link to={`/tutor/booking/${book.id}`}>View Details</Link>
                                            </div>
                                        </div>     
                                    </div>
                                </div>
                            )}
                            {(bookingItems && bookingItems.length === 0) && <div className="col-12 py-3 text-left">Booking not found</div>}
                        </>}
                        <div className="view text-right mt-3 mb-4">
                            <Link to="/tutor/bookings">View All Bookings</Link>
                        </div>
                    </div>
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const configSelector = createSelector(
    state => state.config,
    config => config
);

const mapStateToProps = createSelector(
    processSelector,
    configSelector,
    (process, config) => ({
        process, config
    })
);

export default connect(mapStateToProps)(TutorDashboard);
